<template>
    <div class="editor">
        <el-dialog
            title="编辑文章"
            :visible.sync="showcommonarticleedit"
            width="1000px"
            :before-close="back"
            append-to-body>
            <tin-editor v-if="showcommonarticleedit" :value="article.content" @input="getcontent"></tin-editor>
            <div class="dialog-footer" slot="footer">
                <el-button type="primary" size="default" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import TinEditor from '../tin-editor.vue';
export default {
    name: 'CommonArticleEdit',
    components: {
        TinEditor,
    },
    data() {
        return {
            content: '',
            issave: false,
        }
    },
    props: {
        article: {
            type: Object,
            default: function() {
                return {}
            }
        },
        houseid: {
            type: String,
            default: '',
        }
    },
    computed: {
        showcommonarticleedit: {
            get() {
                var show = this.$store.getters.getshowcommonarticleedit
                return show;
            },
            set(val) {
                this.$store.commit('setshowcommonarticleedit', val);
            },
        }
    },
    methods: {
        save() {
            if (this.article._id) {
                this.updatearticle();
            } else {
                this.addarticle();
            }
        },
        addarticle() {
            var params = {
                id: this.houseid,
                content: this.article.content,
            }
            this.$api.addforeclosurehousearticle(params)
                .then(data=>{
                    this.$message.success(data);
                    this.issave = true;
                    this.$emit('input', this.article.content);
                })
        },
        updatearticle() {
            var params = {
                id: this.article._id['$oid'],
                content: this.article.content,
            }
            this.$api.updateforeclosurearticle(params)
                .then(data=>{
                    this.$message.success(data);
                    this.issave = true;
                    this.$emit('input', this.article.content);
                })
        },
        getcontent(value) {
            this.issave = false;
            this.article.content = value;
        },
        back() {
            if (!this.issave) {
                this.$confirm('内容未保存，是否确定关闭?')
                    .then(_=>{
                        this.showcommonarticleedit = false;
                    })
                return;
            }
            this.showcommonarticleedit = false;
        },
    },
    
}
</script>

<style lang="scss" scoped>

</style>